import { render } from "./GradeMng.vue?vue&type=template&id=00a77975&scoped=true"
import script from "./GradeMng.vue?vue&type=script&lang=js"
export * from "./GradeMng.vue?vue&type=script&lang=js"

import "./GradeMng.vue?vue&type=style&index=0&id=00a77975&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a77975"]])

export default __exports__